import { App03Frameworks, IApp03Workflow } from "./App03Workflow";
import { IApp03WorkItemType } from "./App03WorkItemType";
import { Entity, IEntity } from "./Entity";

export interface IApp03Template extends IEntity {
    Description?: string;
    CreatedByID?: number;
    CreatedOn?: Date;
    ModifiedByUserID?: number;
    ModifiedOn?: Date;
    FrameworkID?: number;
    CustomerID?: number;

    App03WorkItemTypes?: IApp03WorkItemType[];
    App03Workflows?: IApp03Workflow[];
}

export class App03Template extends Entity implements IApp03Template {
    public Description = null;
    public CreatedByID = null;
    public CreatedOn = null;
    public ModifiedByUserID = null;
    public ModifiedOn = null;
    public FrameworkID = null;
    public CustomerID = null;

    public App03WorkItemTypes = [];

    constructor(frameworkID: App03Frameworks) {
        super();
        this.FrameworkID = frameworkID;
    }
}